<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-ibox :is-loading="isLoadingModal">
        <div slot="body">

          <div class="alert alert-warning">
            <span style="color: red;"> توجه: </span>
            لطفا یکی از فیلد های شماره تلفن یا کد ملی را وارد کنید بقیه اطلاعات به صورت اتوماتیک پر می شود
          </div>

          <div class="row">

            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
              disabled
            />

            <bita-input
              type="text"
              name="family"
              label="نام خانوادگی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.family"
              disabled
            />

            <bita-input
              type="text"
              name="phone"
              label="شماره همراه"
              rules="required|mobile"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.phone"
              @change="findDriver(dataForm.phone, 0)"
            />

            <bita-input
              type="text"
              name="nationalCode"
              label="کد ملی"
              rules="required|irani"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.national_code"
              @change="findDriver(0, dataForm.national_code)"
            />

            <bita-textarea
              name="description"
              class="col-12"
              inputClass="col-12 form-control"
              place-holder="توضیحات"
              v-model.lazy="dataForm.description"
            />

            <div class="col-lg-3 mb-1">
              <bita-bootbutton
                type="primary"
                title="اضافه کردن"
                icon="fa fa-check"
                btn-width="150px"
                @click.native="addDriverToBlackList()"
              />
            </div>
          </div>
          <bita-ibox>
            <div slot="body">

              <bita-input
                type="text"
                name="search"
                label="سرچ"
                rules=""
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="search"
                @change="readData()"
                subtitle=" سرچ بر اساس کدملی و شماره موبایل "
              />

              <div  v-if="isLoadingGrid" class="row justify-content-center" >
                <div class="col-auto">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>

              <table class="table" v-else>
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> نام و نام خانوادگی </th>
                    <th scope="col"> شرح </th>
                    <th scope="col">تاریخ ایجاد</th>
                    <th scope="col">عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  
                  <tr v-for=" ( item, index ) in blackList " :key="index" >
                    <th scope="row">{{ index++ }}</th>
                    <td>{{ item.full_name_driver }}</td>
                    <td>{{ item.description ? item.description : '-' }}</td>
                    <td>{{ $getJalaliDateTime(item.created_at) }}</td>
                    <td>
                      <span v-if="item.deleted_at"> حذف شده! </span>
                      <span v-else>
                        <a role='button' @click="deleteDriverFromBlackList(item)" title='حذف'><span class='fas fa-times' style='color:red'></span></a>
                      </span>
                    </td>
                  </tr>

                </tbody>
              </table>

            </div>
          </bita-ibox>
        </div>
      </bita-ibox>
    </div>
    <div slot="footer"></div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: String,
    title: String,
    isLoading: Boolean,
    propsData: Object,
  },

  data() {
    return {
      dataForm: {},
      ownerData: {},
      isLoadingModal: false,
      isLoadingGrid: false,
      colWidth: "col-lg-4",
      blackList: [],
      search: ''
    };
  },

  watch: {
    propsData: function(_data){
        this.ownerData = _data;
    },
  },

  methods: {

    findDriver(phone, national_code) {
      if (this.$ssnIsValid(national_code) || phone.length == 11) {
        this.$persistClient(
          "get",
          `drivers/find?phone=${phone}&national_code=${national_code}`
        ).then((res) => {
          let response = res.data.data;
          if (response) {
            this.dataForm = {
              name: response.name,
              family: response.family,
              phone: response.phone,
              national_code: response.national_code,
            };
          } else {
            this.reset();
          }
        }).catch( () => {
          this.reset();
        });
      }
    },

    reset() {
      this.dataForm = {
        name: "",
        family: "",
        phone: "",
        national_code: "",
        description: "",
      };
    },

    readData() {
      this.isLoadingGrid = true;
      this.$persistClient("get", `black-list?owner_id=${this.ownerData.id}&search=${this.search}`)
        .then((res) => {
          this.blackList = res.data.data;
        })
        .catch(() => {
          this.blackList = [];
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    gridCommands() {
      let commands = [];
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },

    deleteDriverFromBlackList(driver) {
      this.$alert("question", `آیا از حذف  ${driver.full_name_driver} اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.$persistClient(
            "delete",
            `black-list/${driver.id}`
          )
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
            })
            .finally(() => {
              this.readData()
            });
        }
      });
    },

    onCloseModal() {
      this.dataForm = [];
    },

    addDriverToBlackList() {
      let data = {
        ...this.dataForm,
        owner_id: this.ownerData.id
      };
      this.$persistClient("post", `black-list`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
        })
        .finally(() => (
          this.readData()
        ));
    },
  },
};
</script>